import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'aeago_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-navy-dark text-white px-4 py-4 shadow-lg">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm flex-1">
          Usamos cookies para melhorar sua experiência no site. Ao continuar navegando,
          você concorda com nossa{' '}
          <Link
            to="/politica-de-privacidade"
            className="underline text-secondary-light hover:text-secondary"
          >
            Política de Privacidade
          </Link>
          .
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={decline}
            className="text-sm px-4 py-2 border border-white rounded hover:bg-navy-light transition-colors"
          >
            Recusar
          </button>
          <button
            onClick={accept}
            className="text-sm px-4 py-2 bg-secondary hover:bg-secondary-dark rounded font-semibold transition-colors"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
